module.exports = __webpack_public_path__ + "static/img/celoscope-detail-25.ea88dfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-25.jpg
// module id = twxH
// module chunks = 51